module.exports = __webpack_public_path__ + "teqbahn-assets/media/14.de39299b.jpg";